var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVideoUploadFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 30,
    viewBox: "0 0 38 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.646158 18.5781L3.99935 7.70703V17.5994C3.99935 21.3549 7.04381 24.3994 10.7993 24.3994H23.8513C23.8684 24.4659 23.8863 24.5321 23.9051 24.5979L23.58 25.6521C22.7986 28.1852 20.1116 29.6054 17.5784 28.824L3.81813 24.5796C1.28493 23.7983 -0.13521 21.1113 0.646158 18.5781Z",
    fill: "var(--primary-3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2672 0H13.0787L15.9779 3.43242L17.133 4.8L21.3215 4.8L18.4223 1.36757L17.2672 0ZM25.5102 4.8H30C30 2.14903 27.851 0 25.2 0H21.4559L24.4805 3.58087L25.5102 4.8ZM12.9443 4.8L9.13925 0.295065C7.30675 0.970848 6 2.73282 6 4.8H12.9443ZM6 8H30V14.56C26.3484 15.3013 23.6 18.5297 23.6 22.4H10.8C8.14903 22.4 6 20.251 6 17.6V8ZM20.6514 16.266L16.9943 18.9311C16.0902 19.5899 14.8 18.9631 14.8 17.8651V12.5349C14.8 11.4369 16.0902 10.8101 16.9943 11.4689L20.6514 14.134C21.3829 14.667 21.3829 15.733 20.6514 16.266Z",
    fill: "var(--primary-4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.599 28.0887C34.7409 28.0887 37.2879 25.5417 37.2879 22.3998C37.2879 19.2579 34.7409 16.7109 31.599 16.7109C28.4572 16.7109 25.9102 19.2579 25.9102 22.3998C25.9102 25.5417 28.4572 28.0887 31.599 28.0887ZM30.9324 25.9554V23.0665H28.0435V21.7331H30.9324V18.8443H32.2657V21.7331H35.1546V23.0665H32.2657V25.9554H30.9324Z",
    fill: "var(--primary-4)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUploadFilled);
export default __webpack_public_path__ + "static/media/videoUploadFilled.2dbd8efd0e07dfeb8b9a03edeec69dd1.svg";
export { ForwardRef as ReactComponent };